import "./Home.scss";
import { useNavigate } from "react-router";
import { Helmet } from "react-helmet"; // ✅ Import Helmet
import { Link } from "react-router";

export default function Home() {
  const steps = [
  {
    number: "01",
    title: "Prise de contact",
    description:
      "Nous échangeons afin de comprendre votre activité, vos objectifs et vos attentes pour définir les bases de votre projet web.",
  },
  {
    number: "02",
    title: "Analyse & proposition",
    description:
      "J’analyse vos besoins et vous propose une solution adaptée avec une structure claire et un plan de réalisation.",
  },
  {
    number: "03",
    title: "Validation du projet",
    description:
      "Nous validons ensemble les fonctionnalités, le design et les modalités avant le lancement du développement.",
  },
  {
    number: "04",
    title: "Conception & développement",
    description:
      "Création du design puis développement du site avec des technologies modernes, optimisé pour tous les écrans.",
  },
  {
    number: "05",
    title: "Tests & ajustements",
    description:
      "Vérification du bon fonctionnement du site et ajustements selon vos retours pour un résultat optimal.",
  },
  {
    number: "06",
    title: "Mise en ligne & suivi",
    description:
      "Mise en ligne du site puis accompagnement avec maintenance, mises à jour et optimisation continue.",
  },
];
  const navigate = useNavigate();
  const goToPage = (path) => navigate(path);

  return (
    <div className="home">
      {/* ✅ SEO Helmet */}
      <Helmet>
        <title> Nouhayla Er-raysy | Création de site web </title>
        <meta name="description" content="Er-raysy Web & Education propose la création de sites web modernes." />
        <meta name="keywords" content="site web, création site web, développement web, Er-raysy" />
        <meta name="author" content="Nouhayla Er-raysy" />
      </Helmet>

      <section className="hero">
        <h1>Nouhayla Er-raysy</h1>

        
      </section>

      <section className="services">
        <div className="service_card" onClick={() => goToPage("/web")}>
          <p>
            Je propose la création de sites web modernes et responsives pour valoriser votre activité et améliorer 
            votre visibilité. Je conçois également les maquettes et l’identité visuelle du site 
            (couleurs, design, structure) afin de proposer un rendu professionnel et cohérent.
          </p>
          <p>
            Les tarifs de création de site internet sont élaborés pour fournir une solution efficace et raisonnable pour chaque projet. 

Que vous soyez une petite entreprise ou un professionnel indépendant,

nous offrons des services personnalisés en fonction de vos exigences avec des tarifs concurrentiels.
          </p>
        </div>

      <div className="cta_container">
          <a href="https://calendly.com/nouhaylaerrayssy99/30min" target="_blank" rel="noopener noreferrer" className="cta_primary">
            Réserver un appel
          </a>
          <Link to="/contact" className="cta_secondary">
          Demander un devis
          </Link>
        </div>
      </section>

     <section className="why">
  <h2>Pourquoi me choisir</h2>
  <div className="why_container">

    <div className="why_card">
      <h4>Double expertise technique</h4>
      <p>
        Titulaire d’un Bac+5 en bioinformatique et d’un titre professionnel 
        Développeur Web et Web Mobile, j’allie rigueur scientifique et 
        compétences techniques pour des projets fiables et performants.
      </p>
    </div>

    <div className="why_card">
      <h4>Accessibilité & bonnes pratiques</h4>
      <p>
        Je conçois des sites accessibles à tous, respectant les standards du web,
        pour offrir une expérience utilisateur optimale et inclusive.
      </p>
    </div>

    <div className="why_card">
      <h4>Accompagnement personnalisé</h4>
      <p>
        Chaque projet est pensé selon vos objectifs avec un suivi sur mesure
        pour garantir un résultat adapté à votre activité.
      </p>
    </div>

  

  </div>
</section>
      <section className="process">
        <h2>Processus de collaboration</h2>
        <div className="process_container">
          {steps.map((step) => (
            <div className="process_step" key={step.number}>
              <div className="circle">{step.number}</div>
              <div className="step_content">
                <p className="step_title">{step.title}</p>
                <p className="step_description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}